import React from "react";
import { useIntl } from "react-intl";
import { NavLink } from "react-router-dom";

import { cn } from "../cn";
import { ChevronLeft } from "../icons";

export function RedesignPageHeader({
  title,
  backTo,
  status,
  action,
  titleTestId,
  className,
  titleClassName,
}: {
  title: React.ReactNode;
  backTo?: string;
  status?: React.ReactNode;
  action?: React.ReactNode;
  titleTestId?: string;
  className?: string;
  titleClassName?: string;
}) {
  const intl = useIntl();
  return (
    <header className={cn("tw-flex tw-flex-col tw-items-center tw-gap-2 desktop:tw-flex-row desktop:tw-gap-3", className)}>
      <div className="tw-flex tw-w-full tw-items-center tw-gap-2 desktop:tw-w-auto">
        {backTo ? (
          <NavLink
            to={backTo}
            aria-label={intl.formatMessage({ id: "redesign.back", defaultMessage: "Back" })}
            className="tw-flex tw-size-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-text-foreground hover:tw-bg-accent desktop:tw-hidden"
          >
            <ChevronLeft className="tw-size-6" aria-hidden />
          </NavLink>
        ) : null}
        {/* Text-size utilities would override the responsive .rd-page-title rule because Tailwind is important. */}
        <h1 data-testid={titleTestId} className={cn("rd-page-title tw-m-0 tw-flex-1 tw-text-center tw-font-rd-accent tw-text-foreground desktop:tw-flex-none desktop:tw-text-left", titleClassName)}>
          {title}
        </h1>
        {/* Balance the back button so the mobile title remains centred. */}
        {backTo ? <span className="tw-size-8 tw-shrink-0 desktop:tw-hidden" aria-hidden /> : null}
      </div>
      {status ? <div>{status}</div> : null}
      {action ? <div className="desktop:tw-ml-auto">{action}</div> : null}
    </header>
  );
}
